/** Top header — brand mark, current user, sign-out. */
import type { JSX } from "preact";
import { state, isDemoMode } from "../state/store";
import { signOut } from "../supabase";
import { IconsLogo } from "../ui/Brand";
import { displayName, splitName } from "../utils/names";
import { ADMIN_NAME } from "../types";
import { clearCachedState } from "../state/storage";

export function Header(): JSX.Element {
  const s = state.value;
  const isAdmin = s.isAdmin;
  const me = s.currentUser ?? "—";
  const display = isAdmin ? ADMIN_NAME : displayName(me);
  const email = isAdmin ? s.adminEmail : (s.roster[me]?.email ?? "");
  const [first, surname] = isAdmin ? ["A", "D"] : splitName(me);
  const initials = ((surname || first).charAt(0) + (first ? first.charAt(0) : "")).toUpperCase();

  const onSignOut = async (): Promise<void> => {
    if (isDemoMode.value) {
      clearCachedState();
      location.reload();
      return;
    }
    // Sign out FIRST — that's the action that actually invalidates the
    // session. The auth-state listener in App.tsx catches SIGNED_OUT and
    // does the rest (clearSyncBaseline + unsubscribeRealtime + cache
    // clear). Calling them here too would just duplicate work, and the
    // previous version of this handler `await`-ed unsubscribeRealtime
    // BEFORE signOut — which meant a stuck websocket could hang the
    // button forever. Order matters: signOut() needs to win the race.
    void signOut();
  };

  return (
    <header class="top">
      <div class="brand">
        <IconsLogo />
        <span class="brand-sep" aria-hidden="true" />
        <span class="brand-sub">Presence Tracker</span>
      </div>
      <div class="user-box">
        <div class="avatar" aria-hidden="true">{initials}</div>
        <div class="me">
          <strong>
            {display}
            {isAdmin && <span class="admin-badge">Admin</span>}
          </strong>
          <em>{email}</em>
        </div>
        <button type="button" onClick={() => void onSignOut()}>Sign out</button>
      </div>
    </header>
  );
}
